import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

export const fetchNotifications = createAsyncThunk(
  "notifications/fetchNotifications",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.get(`notification-show/${id}`);

      return response.data?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

export const updateNotifications = createAsyncThunk(
  "notifications/updateNotifications",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(`/notification-markAsRead/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

const notificationsSlice = createSlice({
  name: "notifications",
  initialState: {
    notifications: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.notifications = action.payload;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateNotifications.fulfilled, (state) => {
        state.status = "idle";
      });
  },
});

export default notificationsSlice.reducer;
